<template>
  <div class="aws-sku-product-spec-items">
    <div
      v-for="item in list"
      :key="item.amzSkuSpecCode"
      class="aws-sku-product-spec-item"
    >
      <AwsSkuProductSpecItem
        :data="item"
        :buttons="buttons"
        @edit="edit(item)"
        @remove="remove(item)"
        @editImage="editImage(item)"
      />
    </div>

    <div v-if="isEmpty" class="aws-sku-product-spec-empty">
      <img src="/image/static/img/nodata.png" />
      <div class="mt-2">
        <span>
          {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
        </span>
      </div>
    </div>

    <AwsSkuProductSpecEdit
      :visible.sync="editOpts.visible"
      :amzSkuSpecCode="editOpts.amzSkuSpecCode"
      :amzSkuCode="editOpts.amzSkuCode"
      :editImage="buttons.includes('editImage')"
      :isSingle="isSingle"
      :sku="sku"
      @reload="$emit('reload')"
    />

    <AwsSkuEditImages
      :visible.sync="editImageOpts.visible"
      :amzSkuCode="editImageOpts.amzSkuCode"
      @check="checkDefaultImage"
      @reload="$emit('reload')"
    />
  </div>
</template>
<script>
import AwsSkuProductSpecItem from '../aws-sku-product-spec-item'
import AwsSkuProductSpecEdit from '../aws-sku-product-spec-edit'
import AwsSkuEditImages from '../aws-sku-edit-images'
import EditLoading from '@/mixins/edit-loading'
export default {
  components: {
    AwsSkuProductSpecItem,
    AwsSkuProductSpecEdit,
    AwsSkuEditImages,
  },
  mixins: [EditLoading],
  props: {
    list: { type: Array, default: () => [] },
    buttons: { type: Array, default: () => ['edit', 'remove', 'editImage'] },
    isSingle: { type: Boolean, default: false },
    sku: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      editOpts: { visible: false, amzSkuCode: '', amzSkuSpecCode: '' },
      editImageOpts: { visible: false, amzSkuCode: '' },
    }
  },
  computed: {
    isEmpty() {
      return !this.list?.length
    },
  },
  methods: {
    edit({ amzSkuCode, amzSkuSpecCode }) {
      if (!amzSkuSpecCode) return

      this.editOpts = { visible: true, amzSkuCode, amzSkuSpecCode }
    },
    async remove({ amzSkuSpecCode }) {
      if (!amzSkuSpecCode) return

      const confirm = await this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('INDEX.btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return

      this.loadingOpen()
      const res = await this.$api
        .ecomAmzSkuSpecDelApi({ amzSkuSpecCode })
        .catch(() => null)
      this.loadingClose()

      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_delete_no') || '删除失败！')
        return
      }

      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
        type: 'success',
      })

      this.$emit('reload')
    },
    editImage({ amzSkuCode, amzSkuSpecCode }) {
      if (!amzSkuSpecCode) return
      this.editImageOpts = { visible: true, amzSkuCode, amzSkuSpecCode }
    },
    async checkDefaultImage({ displayImageCode, displayImageUrl }) {
      if (!displayImageCode) return

      const { amzSkuSpecCode } = this.editImageOpts

      const res = await this.$api
        .ecomAmzSkuSpecEditImageApi({
          amzSkuSpecCode,
          defaultImageCode: displayImageCode,
          defaultImageUrl: displayImageUrl,
        })
        .catch(() => null)

      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_set_no') || '设置失败')
        return
      }

      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_set_ok') || '设置成功',
        type: 'success',
      })

      this.$emit('reload')
    },
  },
}
</script>

<style lang="scss" scoped>
.aws-sku-product-spec-items {
  .aws-sku-product-spec-item {
    margin-bottom: 15px;
  }
  .aws-sku-product-spec-item:last-child {
    margin-bottom: 0;
  }

  .aws-sku-product-spec-empty {
    height: 400px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: #606266;
    font-size: 14px;
  }
}
</style>
